<template>
  <div  class="w-full flex h-[40px]" :class="{'bg-trader-darkest-gray text-white ' : header }">


    <ul v-if="header" class="flex flex-grow overflow-hidden">
      <li class="w-4 pl-2  leading-10 mr-2"></li>
      <li class="w-8 overflow-hidden leading-9 ">#</li>
      <li class="w-12 overflow-hidden leading-9">EKB.</li>
      <li class="w-16 overflow-hidden leading-9">Art. Nr.</li>


      <li class="leading-9" v-if="headerData" v-for="item in headerData" :class="[ item.size == 0  ? 'flex-grow': '']" :style="{ width: item.size + 'px' }" >
      {{item.label}}
      </li>

    </ul>

    <ul v-else class="flex flex-grow overflow-hidden " :class="{
      'text-red-600 font-bold' : productData.virtualOriginalLastChange > 0,
      'text-yellow-400': productData.virtualOriginalLastChange == 0 && visible && productData.isVirtualArticle,
       'text-yellow-700 dark:text-yellow-400 hover:text-yellow-400' : productData.virtualOriginalLastChange == 0 && productData.isVirtualArticle

    }">
      <li v-if="showCaret && visible" class="w-4 pl-2  leading-10 mr-2">
        <i v-if="!header" class="fa-solid fa-caret-down text-xl "></i>
      </li>
      <li v-if="showCaret && !visible" class="w-4 pl-2  leading-10 mr-2">
        <i v-if="!header" class="fa-solid fa-caret-right text-xl"></i>
      </li>
      <div v-if="!showCaret" class="w-2">

      </div>

      <li  v-if="positionTitle != ''" class="w-8 overflow-hidden leading-9 ">{{positionTitle}}</li>
      <li v-else class="w-8 overflow-hidden leading-9 " :data-ui="productData.positionTitle">
        {{ productData.positionTitle }}
        <i v-if="productData.virtualOriginalLastChange == 0 && productData.isVirtualArticle" class="fa-solid fa-link"></i>
        <i v-if="productData.virtualOriginalLastChange > 0"  class="fa-solid fa-triangle-exclamation"></i>
      </li>

      <li class="w-12 overflow-hidden leading-9 font-bold" >
        <span v-if=" productData.teamIcon != ''" class="rounded p-1" :style="`background-color: #${productData.teamColor}; color: ${getBackgroundColor(productData.teamColor)}`">
        {{ productData.teamIcon }}
        </span>


      </li>
      <li  class="w-16 overflow-hidden leading-9" :data-ui="'header'+ productData.articleNumber"> {{ productData.articleNumber }} </li>

      <li v-for="item in headerData" class="text-nowrap leading-9 overflow-hidden overflow-ellipsis" :class="[ item.size == 0  ? 'flex-grow': '']" :style="{ width: item.size + 'px' }">
        {{ productData[item.field]?.replace("\n", " ") }}
      </li>
    </ul>
  </div>
</template>

<script>


import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

export default {

  props: {
    product: {
      type: Object,
      required: true,
    },
    header: {
      type: Boolean,
      required: false,
    },
    visible: {
      type: Boolean,
      required: false
    },
    formularId: {
      type: Number,
      default: 0,
    },
    positionTitle: {
      type: String,
      default: ''
    },
    showCaret: {
      type: Boolean,
      default: true
    },

    /*
    selectedFormId: {
      handler: function (val, oldVal) {
        this.getProductFormHeader();
      },
      deep: true
    },
     */

  },

  name: "ProductHeader",
  data() {
    let productObj = {
      positionTitle: this.product.positionTitle,
      articleNumber: this.product.articleNumber,
      teamIcon: this.product.teamIcon,
      teamColor: this.product.teamColor,
      isVirtualArticle: this.product.isVirtualArticle,
      virtualOriginalLastChange: this.product.virtualOriginalLastChange,
    };

    if (typeof this.product !== 'undefined') {
      this.product?.productCustomFields.forEach(item => {
        productObj[item.field] = item.value;
      });
    }
    return {
      productData: productObj,
      headerData: [],
      data: this.headerData,
      selectedFormId: this.formularId

    };
  },
  watch: {
    formularId: {
      handler: function (val, oldVal) {
        this.selectedFormId = val;

        this.getProductFormHeader();
      },
      deep: true
    },

  },
  methods: {
    getBackgroundColor(teamColor) {
      // Berechne die Helligkeit der Schriftfarbe
      const color = teamColor.startsWith('#') ? teamColor.substring(1) : teamColor;
      const r = parseInt(color.substr(0, 2), 16);
      const g = parseInt(color.substr(2, 2), 16);
      const b = parseInt(color.substr(4, 2), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // Wähle die Hintergrundfarbe basierend auf der Helligkeit
      return brightness > 125 ? '#000000' : '#FFFFFF';  // Dunkler Hintergrund für helle Schrift und umgekehrt
    },
    async getProductFormHeader() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query    getProductFormHeader($idProductForm: Int!,) {
              getProductFormHeader(idProductForm: $idProductForm){
                idProductFormHeader
                idProductForm
                label
                field
                size

              }
            }
          `,
          variables: {
            idProductForm: this.selectedFormId,
          }
        });

        try {
          this.headerData = response.data.getProductFormHeader;

        } catch (error) {
          console.error(error);
        }

      } catch (error) {
        console.error("Fehler beim Abrufen der getProductFormHeader:", error);
      }
    },
  },
  mounted() {
    this.getProductFormHeader();
   //this.getProductFormHeader(this.formularId)
  },
  created() {
    this.getProductFormHeader();
  }

}
</script>

<style scoped lang="less">

.info-header li {

  list-style-type: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;

}

.header {
  background: gray !important;
  height: 30px;

  line-height: 30px;
  color: white;
}
</style>
  